import { gsap } from '../../global/gsap';

const initEraHero = (element) => {
    const content = element.querySelector('.js-hero-content');
    const media = element.querySelector('.js-hero-media');

    // Timeline for fading in hero els, on complete add trigger class
    // also register scrollTrigger to handle media fading out
    const tl = gsap.timeline({
        paused: true,
        onComplete: () => {
            document.body.classList.add('hero-animated');

            gsap.fromTo(media, { opacity: 1 }, {
                opacity: 0,
                scrollTrigger: {
                    trigger: element,
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true,
                },
            });
        },
    });

    // Animation sequence for hero elements
    tl.to(content.children, {
        delay: 0.25,
        opacity: 1,
        scale: 1,
        duration: 1.5,
        ease: 'power3.out',
        stagger: 0.2,
    }).to(media, {
        opacity: 1,
        duration: 0.5
    }, '-=1.25');

    // Animation can be wonky if fonts not fully loaded
    document.fonts.ready.then(() => {
        tl.play();
    });
};

export { initEraHero as default };
